import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { EMAIL_REGEX, FAILURE_TYPES, FAILURE_NAMES } from '../../validationConstants';
var EMAIL_ERROR_OBJECT = {
  name: FAILURE_NAMES.email,
  type: FAILURE_TYPES.ERROR,
  message: 'Not a valid email'
};
var getErrorObject = function getErrorObject(fieldValue, validationConfig) {
  return _objectSpread(_objectSpread({}, EMAIL_ERROR_OBJECT), {}, {
    value: fieldValue,
    hideBeforeSubmit: !!validationConfig.hideBeforeSubmit
  });
};
export default (function (fieldValue) {
  var validationConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!fieldValue) return null;
  if (!fieldValue.match(EMAIL_REGEX)) return getErrorObject(fieldValue, validationConfig);
  return null;
});